import { injectable } from 'inversify';
import { observable } from 'mobx';

@injectable()
export class UIStatusStore {
    @observable isHeaderSticky = false;
    @observable isContactUsOpen = false;
    @observable isTouchDevice = false;

    scrollableElements: HTMLElement[] = [];

    constructor() {
        window.addEventListener('touchstart', this.onFirstTouch);
    }

    private onFirstTouch = () => {
        this.isTouchDevice = true;
        window.removeEventListener('touchstart', this.onFirstTouch);
    };

    registerScrollable(scrollable: HTMLElement | undefined) {
        if (!scrollable) return;
        const index = this.scrollableElements.indexOf(scrollable);
        if (index > -1) {
            return;
        }
        this.scrollableElements.push(scrollable);
    }

    deregisterScrollable(scrollable: HTMLElement | undefined) {
        if (!scrollable) return;
        const index = this.scrollableElements.indexOf(scrollable);
        if (index > -1) {
            this.scrollableElements.splice(index, 1);
        }
    }

    subscribeOnScroll(el: HTMLElement, handler: (event: Event) => void): () => void {
        const scrollableAncestors = this.getAncestorScrollableElements(el);
        const unsubscribeCallbacks: (() => void)[] = [];
        scrollableAncestors.forEach((sa) => {
            sa.addEventListener('scroll', handler);
            unsubscribeCallbacks.push(() => sa.removeEventListener('scroll', handler));
        });

        return () => unsubscribeCallbacks.forEach((cb) => cb());
    }

    private getAncestorScrollableElements(el: HTMLElement): HTMLElement[] {
        const scrollingContainers = this.scrollableElements.filter((scrollable) =>
            this.scrollableContainsElement(el, scrollable)
        );
        return scrollingContainers;
    }

    private scrollableContainsElement(el: HTMLElement, scrollable: HTMLElement): boolean {
        let element: HTMLElement | null = el;
        while (element) {
            if (element === scrollable) return true;
            element = element.parentElement;
        }

        return false;
    }
}
